{
  "admins": {
    "errors": {
      "add": "Error al agregar administrador.",
      "notFound": "No se pudo encontrar ese administrador."
    }
  },
  "home": {
    "goToSandbox": "Ir al sandbox",
    "subtitle": "Este repositorio es un punto de partida para construir aplicaciones web con React, shadcn-ui y TanStack Router.",
    "title": "Bienvenido a la Plantilla React de Mindsea."
  },
  "login": {
    "errors": {
      "invalidEmail": "Por favor, introduce una dirección de correo electrónico válida.",
      "unauthorized": "No tienes autorización para acceder a esta aplicación."
    },
    "placeholder": "correo@ejemplo.com",
    "sendCode": "Enviar código",
    "subtitle": "Desarrolla la página de inicio de sesión aquí.",
    "title": "Iniciar sesión"
  }
}
